import { render, staticRenderFns } from "./InfrastructureFile.vue?vue&type=template&id=e678b76a&"
import script from "./InfrastructureFile.vue?vue&type=script&lang=js&"
export * from "./InfrastructureFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports